import React from 'react'

import styled from 'styled-components'

import Block from '../../containers/SharedBlock'
import { bh, grayLighter, baseFontSize } from '../../utils/style-utils'
import Container from '../Container'

const Wrapper = styled(Container)`
  padding: ${bh * 2}px;
  color: ${grayLighter};
  font-size: ${baseFontSize * 0.875}px;
  text-align: center;
`

function HomePageDescription() {
  return (
    <Wrapper>
      <Block name="multilotto_site_homepage_description" />
    </Wrapper>
  )
}

export default HomePageDescription
